import { GetServerSidePropsContext, PreviewData } from 'next';

import { ParsedUrlQuery } from 'node:querystring';

import { logger } from '@klokhuis/core/Logger';

export const getLocationBySlug = async (
  ctx: GetServerSidePropsContext<ParsedUrlQuery, PreviewData>,
  citySlug: string,
) => {
  try {
    const { citySlugId, name } = await ctx.req.apiClient.gis.getCityBySlug({
      citySlugId: citySlug,
    });
    return { citySlugId, cityName: name };
  } catch {
    logger.info(`invalid city slug ${citySlug}`);
    return { citySlugId: null, cityName: null };
  }
};

export const getSellersBySlug = async (
  ctx: GetServerSidePropsContext<ParsedUrlQuery, PreviewData>,
  sellerSlug: string,
) => {
  try {
    const { sellerId, displayName } =
      await ctx.req.apiClient.sellers.getSellerBySlug({
        sellerSlugId: sellerSlug,
      });

    return { sellerId, displayName };
  } catch {
    logger.info(`invalid seller slug ${sellerSlug}`);
    return { sellerId: null, displayName: null };
  }
};

export const getSubdomainFromHost = (
  ctx: GetServerSidePropsContext<ParsedUrlQuery, PreviewData>,
): string | null => {
  const host = ctx.req.headers.host?.trim(); // e.g. 'app.freshbuffer.com' or 'localhost:3000'

  if (!host) {
    return null;
  }

  // Remove port if present (e.g. localhost:3000 → localhost)
  const hostname = host.split(':')[0]?.toLowerCase() ?? '';

  // Handle localhost or IPv6
  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '[::1]'
  ) {
    return null;
  }

  // Split into parts (e.g. 'client.freshbuffer.com' → ['client', 'freshbuffer', 'com'])
  const parts = hostname.split('.');

  // Handle localhost subdomains like "client.localhost"
  if (hostname.endsWith('localhost')) {
    return parts.length > 1 ? parts[0] ?? null : null;
  }

  // Ignore 'www' as a subdomain
  if (parts[0] === 'www') {
    parts.shift();
  }

  // For production: 'client.freshbuffer.com' → 'client'
  if (parts.length > 2) {
    return parts[0] ?? null;
  }

  // No subdomain (e.g. 'freshbuffer.com')
  return null;
};
